import {
    TooltipContentPlacement,
    TooltipContentPlacementInUrl,
    TooltipSizeVariantType,
    TooltipsType,
    TooltipTwoLinesSizesPlacementInURLType,
    TooltipTwoLinesSizesPlacementType,
} from 'src/components/ReviewViewer/Tooltips/types';

// const mockTooltips: TooltipsType = [
//     {
//         text: 'Text',
//         coords: new Map([
//             [49, { x: 75.78, y: 47.75 }],
//             [53, { x: 72.52, y: 49.42 }],
//             [61, { x: 57.11, y: 51.42 }],
//             [69, { x: 42.3, y: 51.42 }],
//             [80, { x: 23.33, y: 48.42 }],
//         ]),
//         sizes: {
//             frameIndex: 66,
//             sizes: [
//                 {
//                     variant: TooltipSizeVariantType.TwoLines,
//                     pointCoords: [
//                         { x: 35.19, y: 51.58 },
//                         { x: 58.89, y: 51.92 },
//                     ],
//                     sizeDisplayCoords: { x: 45.26, y: 85.92 },
//                     position: TooltipTwoLinesSizesPlacementType.Horizontal,
//                     text: { text: '\u2205 400 мм', footnoteStartPointCord: { x: 32.07, y: 81.92 } },
//                 },
//             ],
//         },
//     },
//     {
//         text: 'Text_2',
//         coords: new Map([
//             [29, { x: 84.37, y: 40.92 }],
//             [34, { x: 84.37, y: 42.75 }],
//             [43, { x: 78.15, y: 47.58 }],
//             [54, { x: 54.15, y: 50.58 }],
//             [68, { x: 23.63, y: 47.75 }],
//             [77, { x: 14.44, y: 43.58 }],
//         ]),
//         sizes: {
//             frameIndex: 65,
//             sizes: [
//                 {
//                     variant: TooltipSizeVariantType.TwoLines,
//                     pointCoords: [
//                         { x: 25.41, y: 42.08 },
//                         { x: 28.07, y: 72.58 },
//                     ],
//                     sizeDisplayCoords: { x: 2.89, y: 56.75 },
//                     position: TooltipTwoLinesSizesPlacementType.Vertical,
//                     text: { text: '1000 мм' },
//                 },
//             ],
//         },
//     },
//     {
//         text: 'Text_3',
//         coords: new Map([
//             [2, { x: 76.07, y: 49.58 }],
//             [7, { x: 67.78, y: 52.08 }],
//             [12, { x: 58.3, y: 53.25 }],
//             [19, { x: 43.78, y: 53.25 }],
//             [27, { x: 27.19, y: 50.58 }],
//             [31, { x: 22.15, y: 49.08 }],
//         ]),
//         sizes: {
//             frameIndex: 16,
//             sizes: [
//                 {
//                     variant: TooltipSizeVariantType.TwoLines,
//                     pointCoords: [
//                         { x: 24.22, y: 54.58 },
//                         { x: 75.78, y: 54.25 },
//                     ],
//                     sizeDisplayCoords: { x: 48.52, y: 84.92 },
//                     position: TooltipTwoLinesSizesPlacementType.Horizontal,
//                     text: { text: '\u2205 800 мм' },
//                 },
//             ],
//         },
//     },
//     {
//         text: 'Text_4',
//         coords: new Map([
//             [74, { x: 63.63, y: 57.75 }],
//             [80, { x: 56.81, y: 59.42 }],
//             [88, { x: 45.26, y: 60.25 }],
//             [93, { x: 39.04, y: 59.58 }],
//             [2, { x: 32.81, y: 58.75 }],
//             [6, { x: 29.56, y: 57.25 }],
//         ]),
//         sizes: {
//             frameIndex: 90,
//             sizes: [
//                 {
//                     variant: TooltipSizeVariantType.Dot,
//                     objectCoords: { x: 28.67, y: 66.42 },
//                     sizeDisplayCoords: { x: 40.52, y: 78.42 },
//                     text: { top: '4 отв', bottom: '\u2205 5 мм' },
//                 },
//                 {
//                     variant: TooltipSizeVariantType.TwoLines,
//                     pointCoords: [
//                         { x: 42.89, y: 54.92 },
//                         { x: 43.19, y: 65.42 },
//                     ],
//                     sizeDisplayCoords: { x: 75.67, y: 58.92 },
//                     position: TooltipTwoLinesSizesPlacementType.Vertical,
//                     text: { text: '\u2205 300 мм', footnoteStartPointCord: { x: 44.67, y: 23.25 } },
//                 },
//             ],
//         },
//     },
// ];

// const mockTooltips: TooltipsType = [
//     {
//         text: '',
//         coords: new Map([
//             [42, { x: 64.45, y: 62.06 }],
//             [48, { x: 61.8, y: 64.82 }],
//             [53, { x: 57.65, y: 66.1 }],
//             [57, { x: 53.4, y: 66.95 }],
//             [64, { x: 45.75, y: 67.48 }],
//             [71, { x: 37.99, y: 66.31 }],
//             [77, { x: 33.42, y: 64.08 }],
//             [79, { x: 32.47, y: 62.81 }],
//         ]),
//         sizes: {
//             frameIndex: 61,
//             sizes: [
//                 {
//                     variant: TooltipSizeVariantType.Dot,
//                     objectCoords: { x: 36.24, y: 56.98 },
//                     sizeDisplayCoords: { x: 22.33, y: 47.95 },
//                     text: { top: '4 Отв.', bottom: 'М5' },
//                 },
//                 {
//                     variant: TooltipSizeVariantType.TwoLines,
//                     pointCoords: [
//                         { x: 35.14, y: 82.67 },
//                         { x: 64.62, y: 83.14 },
//                     ],
//                     sizeDisplayCoords: { x: 48.82, y: 91.86 },
//                     position: TooltipTwoLinesSizesPlacementType.Horizontal,
//                     text: { text: 'L1' },
//                 },
//             ],
//         },
//     },
//     {
//         text: '',
//         coords: new Map([
//             [90, { x: 62.01, y: 62.7 }],
//             [98, { x: 56.27, y: 65.78 }],
//             [6, { x: 51.38, y: 66.31 }],
//             [15, { x: 42.56, y: 65.89 }],
//             [25, { x: 35.02, y: 63.44 }],
//             [29, { x: 33.74, y: 61.85 }],
//         ]),
//         sizes: {
//             frameIndex: 12,
//             sizes: [
//                 {
//                     variant: TooltipSizeVariantType.TwoLines,
//                     pointCoords: [
//                         { x: 41.12, y: 66.79 },
//                         { x: 50.1, y: 66.79 },
//                     ],
//                     sizeDisplayCoords: { x: 45.87, y: 59.88 },
//                     position: TooltipTwoLinesSizesPlacementType.Horizontal,
//                     text: { text: 'D3' },
//                 },
//                 {
//                     variant: TooltipSizeVariantType.TwoLines,
//                     pointCoords: [
//                         { x: 67.37, y: 83.11 },
//                         { x: 68.33, y: 37.43 },
//                     ],
//                     sizeDisplayCoords: { x: 74.66, y: 58.93 },
//                     position: TooltipTwoLinesSizesPlacementType.Vertical,
//                     text: { text: 'L3' },
//                 },
//                 {
//                     variant: TooltipSizeVariantType.TwoLines,
//                     pointCoords: [
//                         { x: 26.3, y: 84.26 },
//                         { x: 66.69, y: 83.11 },
//                     ],
//                     sizeDisplayCoords: { x: 47.41, y: 90.79 },
//                     position: TooltipTwoLinesSizesPlacementType.Horizontal,
//                     text: { text: 'L2' },
//                 },
//             ],
//         },
//     },
//     {
//         text: '',
//         coords: new Map([
//             [69, { x: 74.02, y: 51.22 }],
//             [73, { x: 69.13, y: 53.88 }],
//             [80, { x: 55.84, y: 57.49 }],
//             [85, { x: 45.11, y: 58.02 }],
//             [94, { x: 27.79, y: 55.37 }],
//             [98, { x: 22.05, y: 52.71 }],
//         ]),
//         sizes: {
//             frameIndex: 85,
//             sizes: [
//                 {
//                     variant: TooltipSizeVariantType.TwoLines,
//                     pointCoords: [
//                         { x: 25.11, y: 58.8 },
//                         { x: 64.36, y: 58.95 },
//                     ],
//                     sizeDisplayCoords: { x: 45.86, y: 32.33 },
//                     position: TooltipTwoLinesSizesPlacementType.Horizontal,
//                     text: { text: 'D1' },
//                 },
//                 {
//                     variant: TooltipSizeVariantType.Dot,
//                     objectCoords: { x: 44.51, y: 57.59 },
//                     sizeDisplayCoords: { x: 67.97, y: 72.18 },
//                     text: { top: 'D2' },
//                 },
//             ],
//         },
//     },
// ];

const mockTooltips: TooltipsType = [
    {
        text: 'Поршневой насос',
        coords: new Map([
            [7, { x: 85.41, y: 48.99 }],
            [11, { x: 81.16, y: 53.13 }],
            [12, { x: 79.93, y: 54.3 }],
            [15, { x: 75.87, y: 56 }],
            [19, { x: 66.34, y: 60.26 }],
            [23, { x: 56.23, y: 61.85 }],
            [28, { x: 42.63, y: 62.06 }],
            [33, { x: 30.17, y: 59.83 }],
            [38, { x: 21.58, y: 56 }],
            [41, { x: 17.8, y: 52.92 }],
        ]),
    },
    {
        text: 'Присоска BX1-A имеет диаметр присоски 254 мм и грузоподъемность до 150 кг. (характеристики для изогнутого стекла: радиус кривизны по дуге ≥ 30 см, радиус кривизны по окружности ≥ 55 см)',
        coords: new Map([
            [77, { x: 55.1, y: 42.83 }],
            [83, { x: 53.68, y: 43.68 }],
            [88, { x: 51.98, y: 44.74 }],
            [1, { x: 48.96, y: 44.63 }],
            [9, { x: 45.85, y: 43.78 }],
            [17, { x: 44.9, y: 42.93 }],
            [21, { x: 45, y: 41.45 }],
        ]),
        sizes: {
            frameIndex: 8,
            sizes: [
                {
                    variant: TooltipSizeVariantType.TwoLines,
                    pointCoords: [
                        { x: 16.1, y: 71.07 },
                        { x: 84.42, y: 72.23 },
                    ],
                    sizeDisplayCoords: { x: 49.4, y: 98.45 },
                    position: TooltipTwoLinesSizesPlacementType.Horizontal,
                    text: { text: '\u2205 254мм' },
                },
            ],
        },
    },
];

const lengthOfBaseOfTriangle = 7;
const lengthOfHeightOfTriangle = 9;

const connectingLineProtrusionLength = 20;

const TooltipContentPlacementFromURLToDefault: {
    [key in TooltipContentPlacementInUrl]: TooltipContentPlacement;
} = {
    [TooltipContentPlacementInUrl.Left]: TooltipContentPlacement.Left,
    [TooltipContentPlacementInUrl.Right]: TooltipContentPlacement.Right,
    [TooltipContentPlacementInUrl.Top]: TooltipContentPlacement.Top,
    [TooltipContentPlacementInUrl.Bottom]: TooltipContentPlacement.Bottom,
};

const TooltipContentPlacementFromDefaultToURL: {
    [key in TooltipContentPlacement]: TooltipContentPlacementInUrl;
} = {
    [TooltipContentPlacement.Left]: TooltipContentPlacementInUrl.Left,
    [TooltipContentPlacement.Right]: TooltipContentPlacementInUrl.Right,
    [TooltipContentPlacement.Top]: TooltipContentPlacementInUrl.Top,
    [TooltipContentPlacement.Bottom]: TooltipContentPlacementInUrl.Bottom,
};

const TooltipSizesPlacementFromURLToDefault: {
    [key in TooltipTwoLinesSizesPlacementInURLType]: TooltipTwoLinesSizesPlacementType;
} = {
    [TooltipTwoLinesSizesPlacementInURLType.Horizontal]:
        TooltipTwoLinesSizesPlacementType.Horizontal,
    [TooltipTwoLinesSizesPlacementInURLType.Vertical]: TooltipTwoLinesSizesPlacementType.Vertical,
};

const TooltipSizesPlacementFromDefaultToURL: {
    [key in TooltipTwoLinesSizesPlacementType]: TooltipTwoLinesSizesPlacementInURLType;
} = {
    [TooltipTwoLinesSizesPlacementType.Horizontal]:
        TooltipTwoLinesSizesPlacementInURLType.Horizontal,
    [TooltipTwoLinesSizesPlacementType.Vertical]: TooltipTwoLinesSizesPlacementInURLType.Vertical,
};

export {
    mockTooltips,
    lengthOfBaseOfTriangle,
    lengthOfHeightOfTriangle,
    connectingLineProtrusionLength,
    TooltipContentPlacementFromURLToDefault,
    TooltipContentPlacementFromDefaultToURL,
    TooltipSizesPlacementFromURLToDefault,
    TooltipSizesPlacementFromDefaultToURL,
};
